module.exports = __webpack_public_path__ + "static/media/Shirt.0e851858.png";